import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Spin } from "antd";

const AuthGuard = ({ children }) => {
    const { token, isLogged } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true); 

    useEffect(() => {
        if (!isLogged || !token || token === '') {
            navigate('/login', { replace: true });
        } else {
            setLoading(false);
        }
    }, [isLogged, token, navigate]);

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <Spin tip="Loading..." size="large" />
            </div>
        );
    }

    return children;
};

export default AuthGuard;